import { createFileRoute } from "@tanstack/react-router";
import { AdminEventsTab } from "@/components/admin/AdminEventsTab";

export const Route = createFileRoute("/_authenticated/admin/events")({
  head: () => ({ meta: [{ title: "Events — Admin" }] }),
  component: AdminEventsPage,
});

function AdminEventsPage() {
  return <AdminEventsTab />;
}
